import React, { Component } from 'react'
import Location from 'components/Location'
import withQueryParams from 'components/withQueryParams'
import { getIsAuthenticated, invalidateSession } from 'redux-simple-auth'
import { connect } from 'react-redux'
import { Redirect, withRouter } from 'react-router-dom'
import { compose } from 'recompose'
import { captureInsecureRedirect } from 'utils/sentry'
import { findPlatform } from 'config/platforms'

class RouteLogout extends Component {
  componentDidMount() {
    const { invalidateSession, isAuthenticated } = this.props

    if (isAuthenticated) {
      invalidateSession()
    }
  }

  render() {
    const { isAuthenticated, query } = this.props
    const redirectUri = query.get('redirect_uri')
    const clientId = query.get('client_id')
    const platform = findPlatform(clientId)

    if (isAuthenticated) {
      return null
    }

    if (redirectUri) {
      captureInsecureRedirect(redirectUri)

      return <Location to={redirectUri} replace />
    }

    if (platform && platform.homeUrl) {
      return <Location to={platform.homeUrl} replace />
    }

    return <Redirect to="/" />
  }
}

const mapStateToProps = state => ({
  isAuthenticated: getIsAuthenticated(state)
})

export default compose(
  withRouter,
  withQueryParams,
  connect(
    mapStateToProps,
    { invalidateSession }
  )
)(RouteLogout)



// WEBPACK FOOTER //
// ./src/routes/logout.js